import { PassengerPriceDetails } from "../../../Orchestrator/Types/Index";
import { IBookingResponse } from "../../../Orchestrator/Types/Types/BookingTypes";
export class ChangeDateContext {

    public routeTo: string[] = [];
    public nextTo: string[] = [];
    public bookingResponse: IBookingResponse | null = null;
    public allFulFillOutBoundPassIds: string[] = [];
    public outBoundPassengerPriceList: PassengerPriceDetails[] = [];
    public allFulFillInBoundPassIds: string[] = [];
    public inBoundPassengerPriceList: PassengerPriceDetails[] = [];
    public previousRoute: string | null = null;
    constructor() {

    }
}